import React from 'react'
import Styles from '../../Css/View360/View360.module.css'

export default function View360HelperText(
    showHelperText
) {
    return (
        <div
            className={`${Styles[window?.innerWidth >667 ?'helperTextContainer':'helperTextContainerMobile']} ${!showHelperText.showHelperText ? Styles['hideHelperTextContainer'] : ''}`}
        >
            <img
                src="https://d20uiuzezo3er4.cloudfront.net/console/icons/raUFXQXzkM.gif"
                alt="handIcon"
                className={[Styles['helperTextHandIcon']]}
                
            />
            <div className={[Styles['helpTextContainerText']]}>Drag to spin</div>
            <div className={[Styles['helpTextContainerTextMobile']]}>Swipe to spin</div>
        </div>
    )
}
